export default __webpack_public_path__ + "static/media/arrow_left.9e617e7e.svg";